import { useEffect, useState } from "react";

/* The fair calendar drives "Now booking", the countdown and the badge. Dates are UTC midnight. */
export const FAIR_SCHEDULE = [
  { cityId: "abu-dhabi", name: "Frieze Abu Dhabi", short: "19–22 Nov 2026", opens: Date.UTC(2026, 10, 19), closes: Date.UTC(2026, 10, 23) },
  { cityId: "doha", name: "Art Basel Qatar", short: "28–30 Jan 2027", opens: Date.UTC(2027, 0, 28), closes: Date.UTC(2027, 0, 31) },
  { cityId: "marrakech", name: "1-54 Marrakech", short: "20–21 Mar 2027", opens: Date.UTC(2027, 2, 20), closes: Date.UTC(2027, 2, 22) },
  { cityId: "dubai", name: "Art Dubai", short: "9–11 Apr 2027", opens: Date.UTC(2027, 3, 9), closes: Date.UTC(2027, 3, 12) },
];

export function currentFair(now = Date.now()) {
  return FAIR_SCHEDULE.find((f) => now < f.closes) || null;
}

export function countdownLabel(fair, now = Date.now()) {
  if (!fair || now >= fair.closes) return null;
  if (now >= fair.opens) return "Open now";
  const days = Math.ceil((fair.opens - now) / 86400000);
  return days === 1 ? "Opens tomorrow" : `Opens in ${days} days`;
}

/* Server/prerender and first client render use the first scheduled fair; the real one is
   resolved after mount and refreshed hourly, so hydration never mismatches. */
export function useCurrentFair() {
  const [state, setState] = useState({ fair: FAIR_SCHEDULE[0], label: null });
  useEffect(() => {
    const tick = () => {
      const now = Date.now();
      const fair = currentFair(now);
      setState({ fair, label: countdownLabel(fair, now) });
    };
    tick();
    const id = setInterval(tick, 60 * 60 * 1000);
    return () => clearInterval(id);
  }, []);
  return state;
}
